/** @type {Record<'offerings', Array<Product>>} */
export const IAPMockedProducts = {
    offerings: [
        {
            id: 'full_access_monthly',
            period: 'monthly',
            price: '1.99 USD',
            subscribed: false,
            title: 'Upgrade to Full',
            unsubscribed: true,
            currencyCode: 'USD',
            priceAsString: '1.99',
            mocked: true,
        },
        {
            id: 'full_access_monthly_sale',
            period: 'monthly',
            price: '1.99 USD',
            subscribed: false,
            title: 'Upgrade to Full',
            unsubscribed: true,
            currencyCode: 'USD',
            priceAsString: '1.99',
            mocked: true,
            introductoryPrice: 'IntroductoryPrice{introPrice: 4.99, introPriceString: 4.99 USD, introPricePeriod: P1M, introPricePeriodUnit: MONTH, introPricePeriodNumberOfUnits: 1, introPriceCycles: 1}',
        },
        {
            id: 'full_access_monthly_2022',
            period: 'monthly',
            price: '4.99 USD',
            subscribed: false,
            title: 'Unlock DentiCalc',
            unsubscribed: true,
            currencyCode: 'USD',
            priceAsString: '4.99',
            mocked: true,
        },
        {
            id: 'full_access_2022_monthly',
            period: 'monthly',
            price: '14.99 USD',
            subscribed: false,
            title: 'Unlock DentiCalc',
            unsubscribed: true,
            currencyCode: 'USD',
            priceAsString: '14.99',
            mocked: true,
        },
    ],
};
